import { CoronaTestResultFile } from './corona-test-result-file.entity';
import { User } from './user.entity';

export class CoronaTestResult {
  id?: number;
  creationDate?: Date;
  testDate?: Date;
  testPositive = false;
  comment?: string;
  files?: CoronaTestResultFile[];
  signature?: string;
  user?: User;
}
